import {
  Component,
  OnInit,
  Inject,
  PLATFORM_ID,
  AfterViewInit,
  ElementRef,
  QueryList,
  ViewChildren,
} from '@angular/core';
import { Meta, Title } from '@angular/platform-browser';
import { Subject } from 'rxjs';
import { NewPageService } from '../new-page/new-page.service';
import { ActivatedRoute, Router } from '@angular/router';
import { formatDate, isPlatformBrowser } from '@angular/common';
import {
  trigger,
  state,
  style,
  animate,
  transition,
} from '@angular/animations';
import { MatDialog } from '@angular/material/dialog';
import { ShareDialogComponent } from './components/share-dialog/share-dialog.component';

@Component({
  selector: 'app-new-page',
  templateUrl: './new-page.component.html',
  styleUrls: ['./new-page.component.scss'],
  standalone: false,
})
export class NewPageComponent implements OnInit {
  school: any = {};
  timerArray = [44555000, 15000, 30000, 60000];
  currentTimerIndex = 0;
  isBrowser: boolean;
  constructor(
    private newPageService: NewPageService,
    private route: ActivatedRoute,
    private router: Router,
    private meta: Meta,
    private title: Title,
    private dialog: MatDialog,
    @Inject(PLATFORM_ID) private platformId: Object
  ) {
    this.isBrowser = isPlatformBrowser(this.platformId);
  }

  ngOnInit(): void {
    // Fetch slug from route parameters
    const slug = this.route.snapshot.paramMap.get('slug');
    if (slug) {
      this.getSchoolData(slug);
      if (this.isBrowser) {
        this.schedulePopUp();
      }
    }
  }
  getSchoolData(slug: string) {
    this.newPageService.getSchoolBySlug(slug).subscribe(
      (res) => {
        if (res.success && res.data) {
          console.log('SSR - School data fetched:', res);
          this.school = res.data;
          this.setMetaTags();
          if (!this.school.theme) {
            this.school.theme = {
              primaryColor: '#0045B0',
              primaryTextColor: '#FFFFFF',
              secondaryColor: '#0058DF',
              secondaryTextColor: '#FFFFFF',
            };
          }
          // Set initial gallery and events
          // this.currentGallery = this.school.gallery.slice(0, this.galleryThreshold);
          // this.getEventsAndNotices(this.school._id);
          // console.log(this.school);
        } else {
          this.router.navigate(['/not-found']);
          console.log('error');
        }
      },
      (error) => {
        console.error('Error fetching school data', error);
        this.router.navigate(['/not-found']);
      }
    );
  }

  setMetaTags(): void {
    this.title.setTitle(`${this.school.name} - Inforida Page`);
    this.meta.addTags([
      { name: 'title', content: `${this.school.name} - Inforida Page` },
      {
        name: 'description',
        content: `${formatDate(Date.now(), 'EEE, dd MMMM YYYY', 'en-US')} : ${
          this.school.about
        } | Discover the story of Inforida, a leading provider of innovative digital solutions for schools. Learn about our mission and commitment to education excellence.`,
      },
      {
        name: 'keywords',
        content: `${this.school.name}, ${this.school.slug}, smart school, school erp, education technology, school performance, schools of future, best school erp, school admission software, fees collection software, school fees, school attendance, school tools, school management, Edtech solutions, Classroom technology, Digital learning tools, School management software, Student information systems, Learning management systems, Educational apps, Academic technology, Online learning platforms, E-learning solutions, Education technology, Classroom management solutions, Customizable digital tools, School administration software, Teacher productivity tools, Parent communication platform, Student performance analytics`,
      },
      { property: 'og:title', content: `${this.school.name} - Inforida Page` },
      {
        property: 'og:description',
        content: `${this.school.about} | Discover the story of Inforida, a leading provider of innovative digital solutions for schools.`,
      },
      { property: 'og:image', content: this.school.logo },
      {
        property: 'og:url',
        content: `https://inforida.com/${this.school.slug}`,
      },
      { property: 'og:type', content: 'website' },
      { name: 'twitter:card', content: 'summary_large_image' },
      { name: 'twitter:title', content: `${this.school.name} - Inforida Page` },
      { name: 'twitter:description', content: this.school.about },
      { name: 'twitter:image', content: this.school.logo },
      {
        name: 'twitter:url',
        content: `https://inforida.com/${this.school.slug}`,
      },
    ]);
  }

  schedulePopUp() {
    if (this.isBrowser) {
      setTimeout(() => {
        const dialogRef = this.dialog.open(ShareDialogComponent, {
          disableClose: true,
          data: {
            slug: this.school.slug,
            baseUrl: 'https://inforida.com/school/',
            fileUrl: this.school.prospectus,
          },
          panelClass: 'custom-dialog-container', // Custom class for animations
          enterAnimationDuration: '500ms',
          exitAnimationDuration: '500ms',
        });
        // dialogRef.afterClosed().subscribe(() => {
        //   this.currentTimerIndex =
        //     (this.currentTimerIndex + 1) % this.timerArray.length;
        //   this.schedulePopUp();
        // });
      }, 10000);
    }
  }

  recordSchoolPageVisit(schoolId) {
    let isNewVisit = true;
    if (isPlatformBrowser(this.platformId)) {
      if (localStorage.getItem(schoolId + 'nv') === 'YES') {
        isNewVisit = false;
      } else {
        localStorage.setItem(schoolId + 'nv', 'YES');
      }
      const data = {
        schoolId,
        isNewVisit,
      };
      this.newPageService
        .recordSchoolPageVisit(data)
        .subscribe((res: any) => {});
    }
  }
}
